import React from 'react';

import MaterialTable from "material-table";

import AddBox from '@material-ui/icons/AddBox';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import {convertISODateTimeToTz} from "../../common/Util";
import Typography from "@material-ui/core/Typography/Typography";
import {useSelector} from "react-redux";

const tableIcons = {
    Add: AddBox,
    Check: Check,
    Clear: Clear,
    Delete: DeleteOutline,
    DetailPanel: ChevronRight,
    Edit: Edit,
    Export: SaveAlt,
    Filter: FilterList,
    FirstPage: FirstPage,
    LastPage: LastPage,
    NextPage: ChevronRight,
    PreviousPage: ChevronLeft,
    ResetSearch: Clear,
    Search: Search,
    SortArrow: ArrowUpward,
    ThirdStateCheck: Remove,
    ViewColumn: ViewColumn
};



const DiariosProducaoTabela = (props) => {
    const diarios = useSelector( st => st.i4.diariosProducao);

    console.log("diarios", diarios);


    const labelProducao = (rd) => {
        let lb = "--";
        switch(rd.producao) {
            case 1:
                lb = "NORMAL";
                break;
            case 2:
                lb = "ABAIXO ESPERADO";
                break;
            case 3:
                lb = "SOBRECARREGADA";
                break;
        }
        return (<Typography>{lb}</Typography>)
    }

    const labelPneus = (rd) => {
        let lb = "--";
        switch(rd.disponibilidadePneus) {
            case 1:
                lb = "DISPONIVEL";
                break;
            case 2:
                lb = "FALTA PARCIAL";
                break;
            case 3:
                lb = "FALTA GRANDE";
                break;
        }
        return (<Typography>{lb}</Typography>)
    }

    const labelMateriaPrima = (rd) => {
        let lb = "--";
        switch(rd.materiaPrima) {
            case 1:
                lb = "DISPONIVEL";
                break;
            case 2:
                lb = "FALTA PARCIAL";
                break;
            case 3:
                lb = "FALTA GRANDE";
                break;
        }
        return (<Typography>{lb}</Typography>)
    }

    const labelPessoal = (rd) => {
        let lb = "--";
        switch(rd.pessoal) {
            case 1:
                lb = "NORMAL";
                break;
            case 2:
                lb = "FALTA PARCIAL";
                break;
            case 3:
                lb = "FALTA GRANDE";
                break;
        }
        return (<Typography>{lb}</Typography>)
    }

    const labelEquipamentos = (rd) => {
        let lb = "--";
        switch(rd.equipamentos) {
            case 1:
                lb = "NORMAL";
                break;
            case 2:
                lb = "PROBLEMA(S) MENORE(S)";
                break;
            case 3:
                lb = "PROBLEMA(S) GRANDE(S)";
                break;
        }
        return (<Typography>{lb}</Typography>)
    }



    const getColumns = () => {
        return [
            {
                title: 'id',
                field: 'id',
                editable: 'never',
                hidden: true
            },
            {
                title: 'Data',
                field: 'data',
                render: rowData => <Typography >{convertISODateTimeToTz(rowData.data).substring(0,10)}</Typography>,
                editable: 'never',
            },
            {
                title: 'Turno',
                field: 'turno',
                editable: 'never',
            },
            {
                title: 'Produção',
                field: 'producao',
                render: rowData => {return labelProducao(rowData)},
                editable: 'never',
            },
            {
                title: 'Pneus',
                field: 'disponibilidadePneus',
                editable: 'never',
                render: rowData => {return labelPneus(rowData)},

            },

            {
                title: 'MATERIA PRIMA',
                field: 'materiaPrima',
                editable: 'never',
                render: rowData => {return labelMateriaPrima(rowData)},

            },
            {
                title: 'PESSOAL',
                field: 'pessoal',
                editable: 'never',
                render: rowData => {return labelPessoal(rowData)},

            },

            {
                title: 'EQUIPAMENTOS',
                field: 'equipamentos',
                editable: 'never',
                render: rowData => {return labelEquipamentos(rowData)},

            }

        ];
    }


        // console.log(ciclos);
        return (
            <React.Fragment>


                        <MaterialTable
                            icons={tableIcons}
                            title="Diários de Produção"
                            columns={getColumns()}
                            data={diarios}
                            onRowClick= {(event, rowData) => {

                            }}
                            actions={[
                                {
                                    icon: 'add',
                                    tooltip: 'Novo diário de produção',
                                    isFreeAction: true,
                                    onClick: (event) => {
                                          props.openDialog(true);
                                         }
                                }
                            ]}

                            options={{
                                filtering: true,
                                pageSize: 15,
                                pageSizeOptions: [10,15,25],
                                addRowPosition: 'first'
                            }}



                        />


            </React.Fragment>
        );

}

export default DiariosProducaoTabela;

